import axios from 'axios';
import { store } from '../store/store';
import appConfig from '../config/appConfig';
import {logout} from "../store/reducers/authReducer";

axios.defaults.cancelToken = null;

const api = axios.create({
  baseURL: appConfig.apiHost + appConfig.apiPath,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((req) => {
  const state = store.getState();
  const auth = state.auth || {};
  if (auth.sessionId) {
    const sessionId = auth.sessionId;
    if (sessionId) {
      req.headers['x-session-Id'] = sessionId;
    }
  }
  return req;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const isNotLoginRoute = error.config?.url !== '/auth/login';
        if (error.response && error.response.status === 401 && isNotLoginRoute) {
            const state = store.getState();
            if (state.auth) {
                store.dispatch(logout());
                setTimeout(() => {
                    window.location.reload();
                }, 100);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
